<template>
  <div>
    <div
      v-if="!showEditLink"
      class="flex flex-col justify-center items-center"
    >
      <img
        v-if="imageUrl && imageUrl !== '' && supportsObjectFit && !loading"
        :src="imageUrl"
        :class="
          size +
            ' ' +
            (isCircleAvatar ? ' rounded-full ' : specificRounded) +
            ' ' +
            (withBorder ? 'border border-indigo-600 border-opacity-50' : '')
        "
        class="object-cover"
      >
      <div
        v-if="imageUrl && imageUrl !== '' && !supportsObjectFit && !loading"
        :class="
          size +
            ' ' +
            (isCircleAvatar ? ' rounded-full ' : specificRounded) +
            ' ' +
            (withBorder ? 'border border-indigo-600 border-opacity-50' : '')
        "
        class="bg-cover"
        :style="'background-image: url(' + imageUrl + ')'"
      />
      <div
        v-if="false"
        class="h-28"
      />
      <icon
        v-if="imageUrl == '' || !imageUrl || loading"
        name="user"
        :class="'text-indigo-600 ' + size"
      />
    </div>
    <div
      v-if="showEditLink"
      @click="showPopupModal"
      class="text-pink-600 italic text-sm cursor-pointer flex flex-col justify-center items-center cursor-camera"
    >
      <img
        v-if="imageUrl && imageUrl !== '' && supportsObjectFit"
        :src="imageUrl"
        :class="
          size +
            ' ' +
            (isCircleAvatar ? ' rounded-full ' : specificRounded)
        "
        class="object-cover"
      >
      <div
        v-if="imageUrl && imageUrl !== '' && !supportsObjectFit"
        :class="
          size +
            ' ' +
            (isCircleAvatar ? ' rounded-full ' : specificRounded)
        "
        class="bg-cover"
        :style="'background-image: url(' + imageUrl + ')'"
      />
      <div
        v-if="false"
        class="h-28"
      />
      <icon
        v-if="imageUrl == '' || !imageUrl"
        name="user"
        :class="'text-indigo-600 ' + size"
      />
      <div
        v-if="showEditLink"
        class="text-pink-600 italic text-sm cursor-pointer"
      >
        Changer d'image
      </div>
    </div>
    <!--vif is necessary to only include one modal at a time (not just hiding it)
            else some methods inside the modals will always call the first rendered modal's method (and using that modal's state),
            not the one it was called from. Just VueJs things...-->
    <!--As an example, let's say the first modal is the one from the component located on the navbar. The modal will have a state relating to the connected user.
            When opening another modal and trying to upload a new image, the url will be constructed with the connected user's id,
            not the one from the currently displayed modal.
        -->
    <profile-picture-modal
      class="cursor-default"
      v-if="showEditLink && popupShown"
      :shown="popupShown"
      :target-object="objectToEdit"
      :specific-media="specificMedia"
      :type-profile-picture="typeProfilePicture"
      @close="popupShown = false"
      @changeProfileImageToAnotherUser="
        (urlPicture) => {
          changeProfileImageToAnotherUser(urlPicture);
        }
      "
    />
  </div>
</template>

<script>
import Icon from './Icon';
import ProfilePictureModal from './ProfilePictureModal';
import { mapGetters } from 'vuex';
export default {
  name: 'ProfilePicture',
  components: { ProfilePictureModal, Icon },
  props: {
    showEditLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: true,
    },
    otherObject: {
      type: Object,
      required: false,
      default: null,
    },
    isCircleAvatar: {
      type: Boolean,
      required: false,
      default: true,
    },
    specificRounded: {
      type: String,
      required: false,
      default: '',
    },
    specificUrl: {
      type: String,
      required: false,
      default: null,
    },
    specificMedia: {
      type: String,
      required: false,
      default: 'profile-picture',
    },
    typeProfilePicture: {
      type: String,
      required: false,
      default: 'users',
    },
    supportsObjectFit: {
      type: Boolean,
      required: false,
      default: true,
    },
    withBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      popupShown: false,
      fileTemp: {},
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      backdoor: 'app/backdoor',
    }),

    imageUrl: {
      get() {
        this.backdoor;

        if (this.specificUrl) {
          return this.specificUrl;
        }
        if (this.otherObject) {
          return this.otherObject.profile_image == null
            ? ''
            : this.otherObject.profile_image;
        } else {
          return this.user.profile_image == null
            ? ''
            : this.user.profile_image;
        }
      },
      set() {
        //
      },
    },

    objectToEdit() {
      return this.otherObject ? this.otherObject : this.user;
    },
  },

  methods: {
    showPopupModal() {
      this.popupShown = true;
    },
    changeProfileImageToAnotherUser(urlPicture) {
      this.$emit('changeProfileImageToAnotherUser', urlPicture);
    },
  },
};
</script>

<style scoped></style>
